var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.paragraphs && _vm.paragraphs.length)?_c('div',{staticClass:"c-about-content"},[_c('div',{staticClass:"c-about-content__gap"}),_c('about-content-list',{attrs:{"paragraphs":_vm.paragraphs}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }